import React from 'react';
import { stage } from '../../../../utils';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';
import AddBoxIcon from '@material-ui/icons/AddBox';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  addStage: {
    width: '100%',
    height: 48,
    marginBottom: theme.spacing(1),
  },
  addIcon: {
    width: theme.spacing(3.5),
    height: theme.spacing(3.5),
  },
}));

interface Props {
  handleAddStage: (stage: string) => void;
}

export default function MobileAddStage({ handleAddStage }: Props) {
  const classes = useStyles();
  function handleClick() {
    handleAddStage(stage.other.value);
  }
  return (
    <Button
      variant="outlined"
      size="large"
      onClick={handleClick}
      className={classes.addStage}
      endIcon={<AddBoxIcon className={classes.addIcon} fontSize="large" />}
    >
      <Typography>Add a New Stage</Typography>
    </Button>
  );
}
